export default {
    language: 'Idioma', english: 'Inglés', spanish: 'Español', japanese: 'Japonés',
    loading: 'Cargando...', submit: 'Enviar', cancel: 'Cancelar', save: 'Guardar', clear: 'Limpiar', close: 'Cerrar',
};
